module.exports = __webpack_public_path__ + "img/logo.8ecf36fe.png";